<div class="loginBody">
    <div class="loginBody-content">
        <h1 class="loginTitle">
            {{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}
        </h1>
        <h2 class="loginHeader">
            {{ 'MODULES.LOGIN.CASINO_ACC_SUBHEADER' | transloco }}
        </h2>
        <div class="vjLoggedIn">
            <div class="vjLoggedIn_profile">
                <figure class="dsProfile dsProfile-T1">
                    <!-- <img class="dsProfile_img" src="src/resources/images/avatar.svg " alt="Profile Image" /> -->
                    <span>T1</span>
                </figure>
                <div>
                    <p>{{ 'MODULES.LOGIN.LOGGED_IN_AS' | transloco }}</p>
                    <h4 class="vjLoggedIn_profile_name">Tier 1</h4>
                </div>
            </div>
            <div class="vjLoggedIn_signout">
                <p>
                    {{ 'MODULES.LOGIN.NOT_YOU' | transloco }}
                    <a class="dsLink"><span class="dsLink_line">{{ 'MODULES.LOGIN.SIGN_OUT' | transloco }}</span></a>
                </p>
            </div>
        </div>
        <div class="vjPlayerPin_number">
            {{ 'MODULES.LOGIN.PLAYER_ACC_NUMBER' | transloco }}
            <b>501079</b>
        </div>
        <p class="vjPlayer-label">{{ 'MODULES.LOGIN.VALIDATE_PIN' | transloco }}</p>
        <div class="dsFieldWrap dsFieldError">
            <div class="dsLabel">{{ 'MODULES.LOGIN.PLAYER_PIN' | transloco }}<sup class="dsAsterix">*</sup></div>
            <mat-form-field appearance="outline" floatLabel="never">
                <input matInput type="text" required minlength="4" maxlength="100" />
            </mat-form-field>
        </div>
    </div>
    <footer class="loginBody-footer">
        <div class="loginAction-forgotOpt">
            <div class="dsFieldWrap">
              <mat-checkbox>{{ 'MODULES.LOGIN.ACCEPT' | transloco }} <a class="dsLink"><span class="dsLink_line">{{
                    'MODULES.LOGIN.TERMS_AND_CONDITIONS' | transloco }}</span></a></mat-checkbox>
            </div>
        </div>
        <button class="loginAction_btn">{{ 'MODULES.LOGIN.SUBMIT' | transloco }}</button>
        <button class="loginAction_btn loginAction_btn-def">{{ 'MODULES.LOGIN.CANCEL' | transloco }}</button>
        <div class="login-copyright">© {{ currentYear }} Light & Wonder, Inc. and its Subsidiaries. All rights reserved
        </div>
    </footer>
</div>